<template>
  <v-container>
    <v-row>
      <v-col class="d-flex justify-center">
        <v-card
          max-width="700"
          border
          flat
          tile
        >
          <v-card-title>
            <h1 class="fs-24">
              {{ $bct('Complete your registration') }}
            </h1>
          </v-card-title>

          <v-divider class="mb-3" />

          <v-card-text>
            <v-row>
              <LabeledTextfield
                v-model="firstName"
                aria-label="First name"
                message="First name"
              />
              <LabeledTextfield
                v-model="lastName"
                aria-label="Last name"
                message="Last name"
              />
            </v-row>
          </v-card-text>

          <v-divider class="my-6" />

          <v-card-actions class="d-flex justify-end">
            <v-btn
              @click="save"
              :loading="processing"
              append-icon="east"
              class="px-8"
              color="primary"
              size="x-large"
            >
              {{ $bct('Save and continue') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

import Api from '@/manager/services/bright_finder';
import LabeledTextfield from '@/shared/components/form/LabeledTextfield.vue';
import useEventBus from '@/shared/composables/useEventBus';

const $bct = inject('translator');

const eventBus = useEventBus();
const router = useRouter();
const store = useStore();
const firstName = ref(null);
const lastName = ref(null);
const processing = ref(false);

async function save() {
  if (!firstName.value || !lastName.value) {
    return eventBus.chime('First and last name are required to continue');
  }
  processing.value = true;

  const response = await Api.manager.profile.updateSelf({
    body: {
      first_name: firstName.value,
      last_name: lastName.value,
    },
  });

  if (response.status !== 200) {
    processing.value = false;
    return;
  }

  const profile = {
    ...store.state.profile,
    first_name: response.data.first_name,
    last_name: response.data.last_name,
  };
  store.commit('setProfile', profile);
  eventBus.chime('Profile saved');

  processing.value = false;

  await router.replace({ name: 'Dashboard' });
}
</script>
